module.exports = __webpack_public_path__ + "img/content9.49f426a9.png";